// GST Type Listing
global.blogList = global.API_ADMIN_URL+'blogList/';
global.adminAddBlog = global.API_ADMIN_URL+'adminAddBlog/';
global.adminEditBlog = global.API_ADMIN_URL+'adminEditBlog/';
global.blogDetails = global.API_ADMIN_URL+'blogDetails/';
global.adminBlogDelete = global.API_ADMIN_URL+'adminBlogDelete/';
global.adminBlogStatus = global.API_ADMIN_URL+'adminBlogStatus/';